import GridIcon1 from '../../assets/grid1-icon.svg?react';
import GridIcon2 from '../../assets/grid2-icon.svg?react';
import GridIcon3 from '../../assets/grid3-icon.svg?react';
import GridIcon4 from '../../assets/grid4-icon.svg?react';
import { useContext } from 'react';
import { ViewContext, CatalogDispatchContext } from '../../store/CatalogContext';

interface SortViewProps {
  group: 'purchased' | 'related' | 'fullCatalog';
  prefix: string;
}

export default function SortView({ group, prefix }: SortViewProps) {
  const viewState = useContext(ViewContext);
  const catalogDispatch = useContext(CatalogDispatchContext);

  const isFullCatalog = group === 'fullCatalog';
  const currentSort = viewState[group].sort;
  const currentGrid = viewState[group].grid;

  const persistView = (updatedView: object) => {
    sessionStorage.setItem(
      'catalogView',
      JSON.stringify({
        ...viewState,
        ...updatedView,
      })
    );
  };

  const handleSortChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const newSort = e.target.value as 'default' | 'a-z' | 'z-a';
    const updatedView = {
      [group]: {
        ...viewState[group],
        sort: currentSort === newSort ? 'default' : newSort,
        pageNumber: 1, // reset page number on sort change
      },
    };

    catalogDispatch({
      type: 'VIEW',
      payload: updatedView,
    });

    persistView(updatedView);
  };

  const handleLayoutChange = (newGrid: 1 | 2 | 3 | 4) => {
    const updatedView = {
      [group]: {
        ...viewState[group],
        grid: newGrid,
      },
    };

    catalogDispatch({
      type: 'VIEW',
      payload: updatedView,
    });

    persistView(updatedView);
  };

  return (
    <div className={`view-controls ${!isFullCatalog ? 'col-12 col-lg-3' : ''} d-flex justify-content-sm-end mt-lg-0`}>
      <div className={`sort-toggle w-100 w-sm-50 w-md-60 w-lg-50 ${!isFullCatalog ? 'w-xl-auto' : ''}`}>
        <div className="dropdown filter-dropdown">
          <button
            className="dropdown-toggle w-100 d-block text-start border rounded"
            type="button"
            data-bs-toggle="dropdown"
            data-bs-auto-close="outside"
            aria-expanded="false"
          >
            Sort<span className="text-uppercase">{currentSort === 'default' ? '' : `: ${currentSort}`}</span>
          </button>
          <ul className="dropdown-menu filter-dropdown-menu w-100">
            <li className="py-1 px-3">
              <div className="form-check mb-0">
                <input
                  className="form-check-input"
                  type="checkbox"
                  value="a-z"
                  id={`${prefix}-a-z`}
                  checked={currentSort === 'a-z'}
                  onChange={handleSortChange}
                />
                <label className="form-check-label d-block" htmlFor={`${prefix}-a-z`}>
                  A-Z
                </label>
              </div>
            </li>
            <li className="py-1 px-3">
              <div className="form-check mb-0">
                <input
                  className="form-check-input"
                  type="checkbox"
                  value="z-a"
                  id={`${prefix}-z-a`}
                  checked={currentSort === 'z-a'}
                  onChange={handleSortChange}
                />
                <label className="form-check-label d-block" htmlFor={`${prefix}-z-a`}>
                  Z-A
                </label>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div className="view-buttons d-none d-sm-flex justify-content-start justify-content-lg-between">
        <button
          className={`grid-icon rounded ${!isFullCatalog ? 'd-lg-none' : ''} ms-1 ${currentGrid === 1 ? 'active' : ''}`}
          aria-label="Grid View 1"
          onClick={() => handleLayoutChange(1)}
          type="button"
        >
          <GridIcon1 aria-label="Grid View 1" />
        </button>
        <button
          className={`grid-icon rounded ms-1 ${currentGrid === 2 ? 'active' : ''}`}
          aria-label="Grid View 2"
          onClick={() => handleLayoutChange(2)}
        >
          <GridIcon2 aria-label="Grid View 2" />
        </button>
        <button
          className={`grid-icon rounded ms-1 d-none  ${isFullCatalog ? 'd-xl-inline-block' : 'd-lg-inline-block'} ${
            currentGrid === 3 ? 'active' : ''
          }`}
          aria-label="Grid View 3"
          onClick={() => handleLayoutChange(3)}
          type="button"
        >
          <GridIcon3 aria-label="Grid View 3" />
        </button>
        {!isFullCatalog && (
          <button
            className={`grid-icon rounded ms-1 d-none d-xl-inline-block ${currentGrid === 4 ? 'active' : ''}`}
            aria-label="Grid View 4"
            onClick={() => handleLayoutChange(4)}
            type="button"
          >
            <GridIcon4 aria-label="Grid View 4" />
          </button>
        )}
      </div>
    </div>
  );
}
